import style from './NavigationBar.module.scss'

interface NavigationBarProps {
    children?: React.ReactNode
}

export default function NavigationBar({ children }: NavigationBarProps) {
    return <div className={style.navigationBar}>{children}</div>
}
